// Password generator - adjustable length + character sets, strength meter, copy.
import { el, btn, input, wrap, copy, announce } from "./ui.js";

const SETS = {
	lower: "abcdefghijklmnopqrstuvwxyz",
	upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
	digits: "0123456789",
	symbols: "!@#$%^&*()-_=+[]{};:,.<>?",
};

function rand(n) { const a = new Uint32Array(n); crypto.getRandomValues(a); return a; }

export function password(root) {
	const s = wrap(root); s.classList.add("rv-pass");
	const out = input("text", { readOnly: true }); out.classList.add("rv-pass-out");
	out.setAttribute("aria-label", "Generated password");
	const len = input("range", { min: "6", max: "48", value: "16" });
	len.id = "rv-pass-len";
	const lenLabel = el("span", "rv-pass-len", "16");
	const toggles = {};
	const meter = el("div", "rv-pass-meter"); const bar = el("div", "rv-pass-bar"); meter.appendChild(bar);
	const strength = el("div", "rv-tnote", "");
	strength.setAttribute("aria-live", "polite");
	meter.setAttribute("aria-hidden", "true");

	function generate() {
		const pool = Object.keys(SETS).filter((k) => toggles[k].checked).map((k) => SETS[k]).join("");
		if (!pool) { out.value = ""; return; }
		const n = parseInt(len.value);
		const r = rand(n);
		let pw = "";
		for (let i = 0; i < n; i++) pw += pool[r[i] % pool.length];
		out.value = pw;
		score(pw, pool.length);
	}
	function score(pw, poolSize) {
		const bits = pw.length * Math.log2(poolSize || 1);
		const pct = Math.min(100, Math.round((bits / 120) * 100));
		bar.style.width = pct + "%";
		const label = bits < 40 ? "Weak" : bits < 60 ? "Fair" : bits < 90 ? "Strong" : "Very strong";
		bar.dataset.level = label.toLowerCase().split(" ")[0];
		strength.textContent = label + " · ~" + Math.round(bits) + " bits of entropy";
	}

	const opts = el("div", "rv-pass-opts");
	[["lower", "a-z"], ["upper", "A-Z"], ["digits", "0-9"], ["symbols", "!@#"]].forEach(([k, label]) => {
		const cb = input("checkbox"); cb.checked = k !== "symbols" ? true : true; toggles[k] = cb;
		const l = el("label", "rv-pass-opt"); l.append(cb, document.createTextNode(" " + label));
		cb.addEventListener("change", generate);
		opts.appendChild(l);
	});
	len.addEventListener("input", () => { lenLabel.textContent = len.value; generate(); });

	const lenText = el("label", "rv-field-label", "Length"); lenText.htmlFor = len.id;
	lenLabel.setAttribute("aria-hidden", "true");
	const lenRow = el("div", "rv-trow"); lenRow.append(lenText, len, lenLabel);
	const outRow = el("div", "rv-pass-outrow");
	const again = btn("↻", generate, "rv-tbtn rv-tbtn-accent");
	again.setAttribute("aria-label", "New password");
	outRow.append(out, btn("Copy", () => { copy(out.value); announce("Password copied"); }, "rv-tbtn"), again);

	s.append(outRow, meter, strength, lenRow, opts);
	generate();
}
